import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import { ReactComponent as Account } from 'assets/accountBig.svg'
import { ReactComponent as Checked } from 'assets/checked.svg'
import { ReactComponent as Safety } from 'assets/safety.svg'
import { useHistory, useParams } from 'react-router-dom'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useReduxSelector } from 'store'
import { useState } from 'react'
import { useRef } from 'react'
import Item from './Item'

interface CameraProps {
  selectedData: payments.SelectedData
  selectData: React.Dispatch<React.SetStateAction<payments.SelectedData>>
  showOutsourcePhotoModal?: basic.BasicFunc
}

const type = process.env.REACT_APP_TYPE

const Camera: React.FC<CameraProps> = ({ selectedData, selectData, showOutsourcePhotoModal }) => {
  const { id } = useParams<warehouse.PageParams>()
  const [photos, setPhotos] = useState<File[] | null>(selectedData?.photos || null)
  const { hasOnlineAccess } = useReduxSelector(state => selectWarehouse(state, id))

  const { goBack } = useHistory()
  const { t } = useTranslation('warehouse')

  const inputRef = useRef<HTMLInputElement>(null)
  const list = (photos || selectedData?.documents)

  return (
    <>
      <input
        ref={inputRef}
        type='file'
        accept='image/*'
        capture='environment'
        style={{ display: 'none' }}
        onChange={e => {
          const { files } = e.target
          if (files && files.length > 0) setPhotos(Array.from(files))
        }}
      />

      <div className='title'>
        <div>{t('takeAPicture')}</div>
        <div>{t('showThatTheWarehouseIsAlreadyEmptyClean')}<br />{t('andReadyForOtherCustomers')}</div>
      </div>

      <div className='resignation__main'>
        <div className='resignation__list'>
          <div className='list__label'>{t('whyPhotos')}</div>

          <Item
            icon={<Safety />}
            title={t('security')}
            desc={t('letsMakeSureYouDidntLeaveAnythingBehind')}
          />

          <Item
            icon={<Checked />}
            title={t('quality')}
            desc={t(`weMakeSureThatTheMAGsAre100Efficient.${type}`)}
          />

          <Item
            icon={<Account />}
            title={t('customersGood')}
            desc={t('everyoneWantsToRentACleanWarehouse')}
          />
        </div>
        {(list && list.length > 0) && <div className='resignation__list --filled'>
          <div className='list__label'>{t('attachedPhotos')}</div>
          <div className='resignation__gallery'>
            {selectedData.documents?.map(({ id, public_path, document_title }) => <div
              key={id}
              className='resignation__gallery__item'>
              <img
                src={public_path}
                alt={document_title}
              />
            </div>)}
            {photos?.map((file, idx) => <div
              key={id}
              className='resignation__gallery__item'>
              <div
                className='resignation__gallery__item__close'
                onClick={() => {
                  setPhotos(photos.length === 1 ? null : photos.filter((_, i) => i !== idx))
                }}>
                <i className='icon icon--close' />
              </div>
              <img
                src={URL.createObjectURL(file)}
                alt={file.name}
              />
            </div>)}
          </div>
        </div>}

        <div className='resignation__buttons'>
          <ArrowBtn
            enlarged
            text={photos
              ? photos.length === 1
                ? t('add1Photo')
                : `${t('add')} ${photos.length} ${t('photos')}}`
              : t(hasOnlineAccess
                ? `openMagAndTakeAPicture.${type}`
                : 'takeAPicture')}
            action={() => {
              if (photos) {
                selectData(prev => ({ ...prev, photos }))
                goBack()
              } else {
                inputRef.current?.click()
              }
            }}
          />

          {showOutsourcePhotoModal && <BackBtn
            text={t('leaveItToUs')}
            action={showOutsourcePhotoModal}
          />}
        </div>
      </div>
    </>
  )
}

export default Camera